module.exports = __webpack_public_path__ + "static/media/2.106a2548.png";